module.exports = __webpack_public_path__ + "img/card2.01a7dd60.png";